const rowHeight = 32;
export const ROW_HEIGHT = `${rowHeight}px`;
export const ROW_HEIGHT_INT = rowHeight;

const footerHeight = 32;
export const FOOTER_HEIGHT = `${footerHeight}px`;
